import o from"./index.module.scss.js";const s=o;export{s as IconTheme};
//# sourceMappingURL=index.js.map
